<template>
  <div class="toast" v-if="show" :style="{ width: isWordsLong ? '55%' : '' }">
    <div class="text" :style="{ fontSize: isWordsLong ? '12px' : '16px' }">{{ text }}</div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      default: '网络异常，请稍候重试',
      type: String
    },
    // 传入的字符串太长的话使用另外一种样式
    isWordsLong: {
      default: false,
      type: Boolean
    }
  },
  data: () => {
    return {
      show: false,
    };
  }
};
</script>

<style lang="stylus" scoped>
.toast {
  z-index: 10000;
  position: fixed;
  display: table;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding-left: 10px;
  padding-right: 10px;
}
.text{
  background: rgba(0, 0, 0, 0.7);
  font-size: 16px;
  color: #fff;
  line-height: 1.8;
  border-radius: 4px;
  padding: 10px 20px;
}
</style>
